export default "__VITE_ASSET__DdICdGrc__"